export const commonConfig = {
  site: 'datadoghq.eu',
  sampleRate: 100,
  service: 'help-centre-webclient',
  env: process.env.REACT_APP_ENV,
  silentMultipleInit: true,
}

export const browserLogsConfig = {
  ...commonConfig,
  clientToken: process.env.REACT_APP_DATADOG_BROWSER_LOGS_TOKEN,
  forwardErrorsToLogs: true,
}

export const RUMSDKConfig = {
  ...commonConfig,
  applicationId: process.env.REACT_APP_DATADOG_RUM_SDK_APP_ID,
  clientToken: process.env.REACT_APP_DATADOG_RUM_SDK_TOKEN,
  trackInteractions: false,
  defaultPrivacyLevel: 'mask-user-input',
}
